import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';

import { actionAuthLogin } from '@core/auth';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gogis-login-modal',
  standalone: false,
  templateUrl: './login-modal.component.html',
})
export class LoginModalComponent {
  /** authentication form. */
  authForm = this.formBuilder.group({
    password: ['', Validators.required],
    username: ['', Validators.required],
  });

  constructor(
    private formBuilder: UntypedFormBuilder,
    private store: Store,
  ) {}

  /** Execute on form login submit. */
  loginClick(): void {
    this.store.dispatch(actionAuthLogin(this.authForm.value));
  }
}
